import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { forkJoin, map, Observable, take } from 'rxjs';

import * as fromStore from 'src/app/_store/_reducers';

@Injectable({
  providedIn: 'root',
})
export class SalesOpsGuard {
  constructor(private store: Store<fromStore.State>) {}
  canActivate(): Observable<boolean> {
    return forkJoin([
      this.store.select((state) => state.user.isSalesOps).pipe(take(1)),
      this.store.select((state) => state.user.isSysAdmin).pipe(take(1)),
    ]).pipe(
      map(([isSalesOps, isSysAdmin]) => {
        return isSalesOps || isSysAdmin;
      })
    );
  }
}
